import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'

declare const gapi: GoogleApi
/* eslint-disable @typescript-eslint/no-explicit-any */
declare const google: any

@Injectable({
    providedIn: 'root',
})
export class GoogleDrivePickerService {
    private clientId = environment.clientId
    private appId = environment.appId

    private pickerCallback: any = null
    private oauthAccessToken: any = null
    private pickerApiLoaded = false

    public openGooglePicker(callback: any): void {
        this.pickerCallback = callback
        if (!this.oauthAccessToken) {
            gapi.load('auth', { callback: this.connectGoogleAccount.bind(this) })
        }

        gapi.load('picker', { callback: this.onPickerApiLoad.bind(this) })
    }

    private connectGoogleAccount(): void {
        const client = google.accounts.oauth2.initTokenClient({
            // eslint-disable-next-line @typescript-eslint/naming-convention
            client_id: this.clientId,
            scope: 'https://www.googleapis.com/auth/drive.readonly',
            immediate: false,
            callback: this.handleAuthResult.bind(this),
        })
        client.requestAccessToken()
    }

    private handleAuthResult(authResult: any): void {
        if (authResult && !authResult.error) {
            this.oauthAccessToken = authResult.access_token
            this.createPicker()
        }
    }

    private onPickerApiLoad(): void {
        this.pickerApiLoaded = true
        this.createPicker()
    }

    private createPicker(): void {
        if (this.pickerApiLoaded && this.oauthAccessToken) {
            const myDriveView = new google.picker.DocsView(google.picker.ViewId.DOCS)
                .setIncludeFolders(true)
                .setOwnedByMe(true)

            const sharedDriveView = new google.picker.DocsView(google.picker.ViewId.TEAM_DRIVES)
                .setIncludeFolders(true)
                .setEnableTeamDrives(true)

            const sharedWithMeView = new google.picker.DocsView(google.picker.ViewId.DOCS_SHARED_WITH_ME)
                .setIncludeFolders(true)
                .setOwnedByMe(false)
                .setLabel('Partagés avec moi')

            const scrollY = window.scrollY

            const preventScroll = (e: Event): void => {
                e.preventDefault()
            }

            const lockScroll = (): void => {
                window.addEventListener('scroll', preventScroll, { passive: false })
                window.addEventListener('wheel', preventScroll, { passive: false })
                window.addEventListener('touchmove', preventScroll, { passive: false })
                window.scrollTo(0, scrollY)
            }

            const unlockScroll = (): void => {
                window.removeEventListener('scroll', preventScroll)
                window.removeEventListener('wheel', preventScroll)
                window.removeEventListener('touchmove', preventScroll)
            }

            const wrapperCallback = (data: any): void => {
                if (
                    data[google.picker.Response.ACTION] === google.picker.Action.PICKED ||
                    data[google.picker.Response.ACTION] === google.picker.Action.CANCEL
                ) {
                    unlockScroll()
                }

                if (this.pickerCallback) {
                    this.pickerCallback(this.oauthAccessToken, data)
                }
            }

            const picker = new google.picker.PickerBuilder()
                .addView(myDriveView)
                .addView(sharedDriveView)
                .addView(sharedWithMeView)
                .setAppId(this.appId)
                .setOAuthToken(this.oauthAccessToken)
                .setCallback(wrapperCallback)
                .setLocale('fr-FR')
                .build()

            picker.setVisible(true)
            lockScroll()
        }
    }
}

interface GoogleApi {
    load(param1: string, param2: unknown): void
}
